/** How an API access authenticates; chosen on create, never changed. */
export enum ApiAuthMethod {
  //A secret generated by the BE, shown once.
  ApiKey = 'API_KEY',
  //The partner keeps a private key, the BE stores only its public key.
  SigningKey = 'SIGNING_KEY',
}
